import { brandWithImage } from './brandWithImage';
import type { CategoryItem } from './category';

export interface BrandCategory {
  id: string;
  title: string;
  brands: CategoryItem[];
}

const findBrandsByNames = (brandNames: string[]): CategoryItem[] => {
  return brandNames
    .map((name) => {
      const brand = brandWithImage.find((item) => item.name.toLowerCase() === name.toLowerCase());
      return brand;
    })
    .filter((brand): brand is CategoryItem => brand !== undefined);
};

interface CategoryDefinition {
  type: string;
  brandNames: string[];
}

const categoryDefinitions: CategoryDefinition[] = [
  {
    type: 'Acne & Blemish-Prone Skin',
    brandNames: ['COSRX', 'SOME BY MI', 'SKIN1004', 'Benton', 'Dr. Oracle', 'Medicube'],
  },
  {
    type: 'Sensitive Skin',
    brandNames: ['Aestura', 'ROUND LAB', 'abib', 'Biodance', 'Anua', 'COSRX'],
  },
  {
    type: 'Dry Skin',
    brandNames: ['Laneige', 'Dr. Jart+', 'Illiyoon', 'Pyunkang Yul', 'Belif', 'Skinfood'],
  },
  {
    type: 'Anti-Aging, Firming and Brightening',
    brandNames: ['MISSHA', 'Beauty of Joseon', 'ma:nyo', 'Sulwhasoo', 'CKD', 'AHC'],
  },
  {
    type: 'Sunscreen & UV Protection',
    brandNames: ['Round Lab', 'Isntree', 'Innisfree', 'Tonymoly', 'Holika Holika', 'd’alba'],
  },
  {
    type: 'Cruelty-Free',
    brandNames: ['Isntree', 'Dear Klairs', 'I’m From', 'Purito', 'Axis-Y', 'Benton'],
  },
];

const generateBrandCategories = (): BrandCategory[] => {
  return categoryDefinitions.map((def, index) => ({
    id: (index + 1).toString(),
    title: `Best in ${def.type}`,
    brands: findBrandsByNames(def.brandNames),
  }));
};

export const BRAND_CATEGORIES: BrandCategory[] = generateBrandCategories();

export default BRAND_CATEGORIES;
